import { StateEntity } from '../entities/state-entity';

export default class State {
  current_country_id = '';

  items: Array<StateEntity> = [];
}
